module.exports = __webpack_public_path__ + "static/media/galleryImg4.400212fa.jpg";